import { render, staticRenderFns } from "./AdManagement.vue?vue&type=template&id=50f01085&scoped=true&"
import script from "./AdManagement.vue?vue&type=script&lang=js&"
export * from "./AdManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdManagement.vue?vue&type=style&index=0&id=50f01085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f01085",
  null
  
)

export default component.exports